var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pb==='豎排')?_c('div',{staticClass:"text_box",attrs:{"id":"read_right"}},_vm._l((_vm.item.list),function(child,childIndex){return _c('div',{key:childIndex,staticClass:"text",staticStyle:{"zoom":"0.35","font-size":"40px"},style:({
  left:child.box[0]+'px',
  marginTop: child.box[1]+'px'
    })},[_vm._v(_vm._s(' '+ child.text +' '))])}),0):_c('div',{staticClass:"text_box",staticStyle:{"display":"block"}},_vm._l((_vm.item.list),function(child,childIndex){return _c('span',{key:childIndex,style:({
    })},[_vm._v(_vm._s(' '+ child.text +' '))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fb010a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/com/textPage.vue
// module id = null
// module chunks = 